export default __webpack_public_path__ + "static/media/parabens.da6b5717.png";